import * as React from 'react';
import * as ConfirmStore from '@/redux/ui/confirm';
import * as ProductEditStore from '@/redux/pages/product-edit';

import { connect } from 'react-redux';
import { PickerBox } from '@/pages/components/picker';
import { parse } from 'query-string';

import config from '@/server/config';
import request from '@/server/request';
import store from '@/redux';

const Toast = require('react-toast-mobile');

class ProductPhysical extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        let index = Number(parse(props.location.search).index || 0);
        if (!props.parameter[index]) { 
            index = 0;
        }
        this.state = {
            index,
            unitList: [], // 组分内容
            nameId: props.parameter[index].id, // 名称id
            modelName: props.parameter[index].name, // 名称
            modelPhysical: props.parameter[index].physical, // 物性值
            modelUnit: props.parameter[index].unit, // 单位
            unitId: props.parameter[index].unitId, // 单位id
            modelRemarks: props.parameter[index].remarks, // 备注
            source: parse(this.props.location.search).source
        };
    }

    public componentDidMount() { 
        if (this.state.modelName !== '') { 
            const temp = this.props.parameter;
            temp[this.state.index].unit = '';
            temp[this.state.index].unitId = '';
            store.dispatch({
                type: ProductEditStore.types.INPUT,
                data: {
                    key: 'parameter',
                    value: temp
                }
            });
            this.getUnit();
        }
    }

    public render() {
        const state = this.state;
        return (
            <section className="expert-edit">
                <div className="expert-edittop">
                    <div className="expert-edititem" onClick={() => this.navigateTo('/u/product/selectphysical?index=' + this.state.index)}>
                        <div className="expert-editlabel">
                            <span>*</span>
                            物性名称
                        </div>
                        <div className="expert-editgroup">
                            <p className={state.modelName ? 'active' : ''}>{state.modelName || '请选择'}</p>
                            {
                                this.state.source !== '4' ?
                                <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /> : null
                            }
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            物性值
                        </div>
                        <div className="expert-editgroup">
                            <input type="text" placeholder="请输入"
                                value={state.modelPhysical}
                                onChange={() => this.inputChange('modelPhysical')}
                                readOnly={this.state.source === '4'}
                            />
                        </div>
                    </div>
                    <div className="expert-edititem" onClick={() => this.selectUnit()}>
                        <div className="expert-editlabel">
                            <span>*</span>
                            单位
                        </div>
                        <div className="expert-editgroup">
                            <p className={state.modelUnit ? 'active' : ''} dangerouslySetInnerHTML={{ __html: state.modelUnit || '请选择' }}></p>
                            {
                                this.state.source !== '4' ?
                                <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /> : null
                            }
                        </div>
                    </div>
                    <div className="expert-edititem flex-vstart">
                        <div className="expert-editlabel">
                            备注
                        </div>
                        <div className="expert-editgroup">
                            <textarea placeholder="请输入" value={state.modelRemarks}
                                onChange={() => this.inputChange('modelRemarks')} readOnly={this.state.source === '4'} />
                        </div>
                    </div>
                </div>
                {
                    this.state.source !== '4' ?
                        <div className="expert-editbottom">
                            <button className="btn-submit" onClick={() => this.confirmAction()}>确定</button>
                            {
                                state.index > 0 ? <button className="btn-delete-a" onClick={() => this.removeAction()}>删除</button> : null
                            }
                        </div> : null
                }
            </section>
        )
    }

    // 获取单位
    private async getUnit() {

        const r = await request({
            url: `${config.ULKAPI}api/web/index.php?r=member/product/physical-com`,
            method: 'post',
            data: {
                id: this.props.parameter[this.state.index].id
            }
        });
        
        if (r.error_code === 0) { 
            const temp = r.data.map((v: any) => { 
                return {
                    value: v.id,
                    name: v.com_name.replace(/(<.*?\>)|(<\/.*?>)/img, '')
                }
             });
            this.setState({
                unitList: temp
            });
        }

    }

    /**
     * 处理输入框文本变化
     * @param modelName {string} 模块名称
     */
    private inputChange(modelName: string) {
        this.setState({
            [modelName]: (event as any).target.value
        });
    }

    // 选择成分
    private selectUnit() { 

        if (this.state.source === '4') { 
            return;
        }

        if (this.state.unitList.length === 0) { 
            return Toast.T.notify('请先选择物性名称');
        }

        (PickerBox as any).open({
            data: [{
                displayValue(item: any) {
                    return item.name;
                },
                list: this.state.unitList,
            }],
            // 成功回调
            onConfrim: (data: any) => {
                this.setState({
                    modelUnit: data.name,
                    unitId: data.value
                });
            }
        });

    }

    // 确定
    private confirmAction() {

        if (this.state.nameId === '') {
            return Toast.T.notify('请选择物性名称');
        } else if (this.state.modelPhysical === '') {
            return Toast.T.notify('请填写物性值');
        } else if (!/^[0-9±≥≤＞＜-]+$/img.test(this.state.modelPhysical)) {
            return Toast.T.notify('物性值只支持数字± 、≥、≤、＞、＜、-组成');
        } else if (this.state.unitId === '') {
            return Toast.T.notify('请选择单位');
        } else if (this.state.modelRemarks.length > 100) { 
            return Toast.T.notify('备注最多100个字');
        }

        const temp = this.props.parameter;
        temp[this.state.index] = {
            id: this.state.nameId,
            name: this.state.modelName,
            physical: this.state.modelPhysical,
            unit: this.state.modelUnit,
            unitId: this.state.unitId,
            remarks: this.state.modelRemarks,
        };
        store.dispatch({
            type: ProductEditStore.types.INPUT,
            data: {
                key: 'parameter',
                value: temp
            }
        });

        this.props.history.goBack();

    }

    // 删除
    private removeAction() { 
        store.dispatch({
            type: ConfirmStore.types.CONFIRM_SHOW,
            data: {
                text: '是否确认删除?',
                onConfirm: () => { 
                    setTimeout(() => { 
                        const temp = this.props.parameter;
                        temp.splice(this.state.index, 1);
                        store.dispatch({
                            type: ProductEditStore.types.INPUT,
                            data: {
                                key: 'parameter',
                                value: temp
                            }
                        });

                        this.props.history.goBack();
                    });
                }
            }
        });
    }

    /**
     * 跳转到对应页面
     * @param path 
     */
    private navigateTo(path: string) {
        
        if (this.state.source === '4') { 
            return;
        }

        this.props.history.push(path);

    }

}

const mapStateToProps = (state: any): ProductEditStore.IProductEditState => { 
    return {
        ...state.productEditReducers
    }
}

export default connect(mapStateToProps)(ProductPhysical);